(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2264],{

/***/ 271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./common/data/bank_country.json
var bank_country = __webpack_require__(55881);
// EXTERNAL MODULE: ./common/data/bank_emis.json
var bank_emis = __webpack_require__(33148);
// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/common/open-bank-account/index.js + 1 modules
var open_bank_account = __webpack_require__(53001);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/cyprus/open-bank-account/data.json
var data_namespaceObject = JSON.parse('{"country":"Cyprus","imgAlt":"open a bank account for Cyprus company","breadcrumbs":[{"title":"Company Formation","uri":"/company-formation"},{"title":"Cyprus","uri":"/company-formation/cyprus"},{"title":"Open bank account","uri":"/company-formation/cyprus/open-bank-account"}],"dataPageType":[{"title":"Company Formation","uri":"/company-formation/cyprus"},{"title":"Open Bank Account","uri":"/company-formation/cyprus/open-bank-account"},{"title":"Other Services","uri":"/company-formation/cyprus/other-services"}],"dataHowToOpen":{"title":"Can Cyprus Company Open A Bank Account <br/>Overseas?","content":["<p>One initial step to start your offshore business venture is to apply for a ​business bank account. This allows business owners to keep their business depositing and expenditure separate from personal accounts, meaning better limited liability protection and enhanced credibility for your business. As for Cyprus company, there are common application choices to open your business account:</p>","<h3 class=\'font-medium text-bbc-brand-700\'>Applying in a local bank in Cyprus</h3>","<p>The Republic of Cyprus, located to the south of Turkey, is a member of the European Union (EU). Its corporate income tax rate at 12.5 % is the lowest among all EU countries.</p>","<p>Cyprus’s banking sector is regulated under Central bank of Cyprus, and under the direct supervision of European Central Bank (ECB) within the framework of Single Supervisory Mechanism (SSM) provisions, which has come into effect since Nov 2014</p>","<p>Since the financial crisis in 2013, Cyprus has undergone economic reform to enhance its financial stability and improve functions of the banking sector. Until now, high bad debt (non-performing loans) still remains as a challenge facing the future of Cypriot banking system.</p>","<p>Banks in Cyprus are classified into two groups: domestic-oriented banks and international banks. Three key players in the banking landscape are Bank of Cyprus, Hellenic Bank and RCB bank, the remainders are occupied by over 25 branches and subsidiaries of international banks in EU and other countries.</p>","<h3 class=\'font-medium text-bbc-brand-700\'>Going for offshore bank accounts or fintech solutions</h3>","<p>We currently don’t support opening bank accounts in Cyprus. Fortunately, we can set up your Cypriot company bank account in other jurisdictions including financial centres like Singapore, where you can find a reputable banking system with no foreign exchange control.</p>"]},"dataRequiredDocument":{"note":"","button":{"type":"talk-to","text":"Talk To Our Expert"},"content":[{"title":"Different banks might demand a distinct set of documents for account opening process on a case-by-case basis. The below list presents some common documents required by most banks.","listContent":[{"text":"Account application forms","content":[]},{"text":"Bank statements","content":[]},{"text":"Bank reference letter","content":[]},{"text":"Certified copies of passports, proofs of residence for all directors/shareholders","content":[]},{"text":"Business plan","content":[]},{"text":"Business trading proofs (sales/purchase orders, invoice…)","content":[]},{"text":"Certified copies of Cyprus company incorporation documents","content":[]},{"text":"Government certification of company good standing status.","content":[]}]},{"title":"You had better consult BBCIncorp to know the exact documents needed for your case."}]}}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/cyprus/open-bank-account/index.js






var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "offshore",
    navLight: true,
    page: data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(open_bank_account/* default */.Z, {
      data: data,
      dataJson: data_namespaceObject,
      dataBank: {
        traditional: bank_country/* cyprus */.UG,
        emi: bank_emis/* cyprus */.UG
      }
    })
  });
}

/***/ }),

/***/ 62398:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/company-formation/cyprus/open-bank-account",
      function () {
        return __webpack_require__(271);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,9973,5955,9131,4090,9738,7447,2864,58,5881,5999,6618,2888,179], function() { return __webpack_exec__(62398); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);